import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Button, Tooltip, Spin } from 'antd';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import { Field } from 'react-final-form';
import * as yup from 'yup';
import { asyncConnect } from 'react-async-client';

import { recovery } from 'constants/routes';
import ErrorHTML from 'components/common/form/ErrorHTML';
import GuestInput from 'components/common/form/GuestInput';
import GuestFooter from 'components/layout/guest/GuestFooter';
import withFormWrapper from 'components/hocs/withFormWrapper';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { login } from 'actions/userActions';
import Captcha from './Captcha';
import CustomIcon from 'components/common/CustomIcon';

const getCaptcha = path(['error', 'data', 'code']);

const validationSchema = yup.object().shape({
    email: yup.string().required(),
    password: yup.string().required(),
});

const stateToProps = ({ license, sessionOver }) => ({ license, sessionOver });

@withAutoFocusForm
@asyncConnect({
    formAction: login
}, (store, { location: { state } }) => ({ initialValues: state }))
@withFormWrapper({
    validationSchema,
    mapPropsToValues: props => props.initialValues
})
@connect(stateToProps)
@withRouteOptions
export default class LoginView extends Component {
    static propTypes = {
        formAction: PropTypes.object.isRequired,
        license: PropTypes.bool,
        sessionOver: PropTypes.bool
    }

    static routeOptions = {
        title: 'menu.login'
    };

    render() {
        const { license, sessionOver, formAction: { meta } } = this.props;
        const captcha = getCaptcha(meta);

        const noLicenseMessage = license && <Alert className="guest-layout-error" type="error" message={<Translate content="error.55" unsafe />} />;
        const sessionOverMessage = sessionOver && <Alert className="guest-layout-error" type="error" message={<Translate content="error.6" />} />;

        return (
            <Fragment>
                <Spin spinning={Boolean(meta.pending)}>
                    { noLicenseMessage }
                    { sessionOverMessage }
                    { meta.error && <ErrorHTML meta={meta} className='guest-layout-error' /> }
                        <Field
                            name="email"
                            component={GuestInput}
                            type="text"
                            placeholder="guest.login"
                            prefix={<CustomIcon type="user-man" />}
                            notWrap
                        />
                        <Field
                            name="password"
                            component={GuestInput}
                            type="password"
                            placeholder="guest.password"
                            prefix={<CustomIcon type="unlock" />}
                            pending={meta.pending}
                            visibilityToggle={false}
                            notWrap
                        />
                        { captcha && (
                            <div className="login-captcha-container">
                                <Captcha captcha={captcha} />
                                <Tooltip title={<Translate content="guest.captchaRefresh" />} placement="right">
                                    <Button htmlType="submit">
                                        <CustomIcon type="refresh" />
                                    </Button>
                                </Tooltip>
                            </div>
                        )}

                        <Button htmlType="submit" type="primary" size="large" className="login-form-button">
                            <Translate content="guest.toLogin" />
                        </Button>
                </Spin>
                <GuestFooter>
                    <Link to={recovery.path} className="login-form-forgot">
                        <Translate content="guest.forgotPassword" />
                    </Link>
                </GuestFooter>
            </Fragment>
        );
    }
}
